import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppData } from './data-store';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { UrlSettingsCore } from './core/configuration/url-settings-core';

@Injectable({
  providedIn: 'root'
})
export class SsoStrategyService {
  private _forbidden = new BehaviorSubject<boolean>(false);
  forbidden = this._forbidden.asObservable();
  private authMode: string = 'ldap';

  constructor(private http: HttpClient, private router: Router) {}

  loadAuthConfig(): Promise<string> {
    return new Promise((resolve, reject) => {
      if(environment.SSO_STRATEGY) {
        this.authMode = environment.SSO_STRATEGY;
        // AppData.getInstance().SSO_STRATEGY = environment.SSO_STRATEGY;
        resolve(environment.SSO_STRATEGY)
      } else {
        reject("Errore di configurazione del processo di login, contattare l'amministratore di sistema");
        this._forbidden.next(true);
        this.router.navigate([UrlSettingsCore.URL_FORBIDDEN]);
      }
    })
  }

  getAuthMode(): string {
    return this.authMode.toLowerCase();
  }

  onForbidden(param: boolean) {
    this._forbidden.next(param);
  }
}
